import React from 'react';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './LogoSection.module.css';

const LogoSection: React.FC = () => {
  const uhLogoPath = '/web_v2/uh-x-diesel/logos/uh.png';
  const dieselLogoPath = '/web_v2/uh-x-diesel/logos/diesel.png';

  return (
    <section
      className={styles.section}
      aria-label="Ultrahuman and Diesel collaboration logos"
    >
      <div className={styles.container}>
        <div className={styles.logoWrapper}>
          <img
            className={styles.dieselLogo}
            src={getCompressedAssetUrl(dieselLogoPath)}
            alt="Diesel logo"
            loading="lazy"
          />
        </div>
        <div className={styles.divider} aria-hidden="true" />
        <div className={styles.logoWrapper}>
          <img
            className={styles.uhLogo}
            src={getCompressedAssetUrl(uhLogoPath)}
            alt="Ultrahuman logo"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default LogoSection;
